// TODO Secure Message
export const apiStringFieldMaxLength = 1000000;

export const apiVersions = {
  authServices: '0.8.0',
  casCaseServices: '0.8.0',
  caseServices: '0.8.0',
  csapCaseServices: '1.0.0',
  customerServices: '1.0.0',
  eventServices: '0.8.0',
  referenceServices: '1.0.0',
  userCredentialServices: '0.8.0',
  userServices: '0.8.0',
  timelineService: '0.8.0', // TODO: Need to find API version
  accountTranService: '0.8.0',
  projectionService: '1.0.0',
  tagManagementService: '1.0.0',
  alertService: '0.8.0',
  sweepService: '0.9.0',
  nbaService: '1.4.0', // changes for NBA from 1.2.0 => 1.4.0
  payeeService: '0.8.0',
  paymentServices: '0.8.0',
  mandateService: '1.0.0',
  accountService: '0.8.0',
  getPots: '0.8.0',
  spendingDataService: '0.8.0',
  tagListService: '1.0.0',
  setStatementPreferences: '0.8.0', // 0.8.0
  getStatementServices: '1.2.0',
  malwareServices: '1.0.0',
  wbaService: '0.8.0',
  samlServices: '1.2.0',
  orderStatement: '1.2.0',
  orderCheque: '1.2.0',
  orderPayin: '1.2.0',
  renameServices: '0.8.0',
  cma: '0.8.0',
  securreMessageDataService: '1.2.0',
  userVerifications: '1.2.0',
  bfmServices: '2.0.0',
  preferenceServices: '0.8.0',
  transactionsExport: '1.2.0',
  lastLoginService: '1.0.0',
};
